export enum DimensionSystem {
  METRIC = 'METRIC',
  IMPERIAL = 'IMPERIAL',
}
